import { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, TextField, Typography } from "@mui/material";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { api } from "../../api/api";
import GradientButton from "./GradiantButton";

const VerifyOtp = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const [otp, setOtp] = useState(["", "", "", ""]);
  const [timer, setTimer] = useState(300);
  const inputRefs = useRef([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimer((t) => (t > 0 ? t - 1 : 0));
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleVerifyOtp = async () => {
  const otpValue = otp.join(""); // Convert array to string like "1713"

  if (!otpValue) {
    toast.error("Enter OTP");
    return;
  }
  if (timer <= 0) {
    toast.error("OTP expired");
    return;
  }
  try {
    const res = await api.VerifyOtp({ email, otp: otpValue });

    if (res.status === 200) {
      toast.success("OTP verified successfully");
      navigate("/reset-password", { state: { email } });
    }
  } catch (err) {

    toast.error(err.response?.data?.message || "Invalid OTP");
  }
};


  const handleChange = (value, index) => {
    if (/^[0-9]?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to next input if value is entered
      if (value && index < 3) {
        inputRefs.current[index + 1].focus();
      }
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputRefs.current[index - 1].focus();
    }
  };
  const formatTime = (sec) =>
    `${Math.floor(sec / 60).toString().padStart(2, "0")}:${(sec % 60)
      .toString()
      .padStart(2, "0")}`;

  return (
    <>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "white",
          minHeight: "100vh",
        }}
      >
        <Box
          sx={{
            width: {xs:"100%",sm:400} ,
            bgcolor: "white",
            p: 4,
            borderRadius: 2,
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
          }}
        >
          <Typography
            variant="h5"
            align="center"
            sx={{ mb: 3, fontWeight: "bold" }}
          >
            OTP Verification
          </Typography>

          <Typography sx={{ marginBottom: 3 }}>
            Please Enter the OTP sent to your registered email to complete your verification
          </Typography>
          <Box sx={{ display: "flex", gap: 2, justifyContent: "center", mb: 4 }}>
            {otp.map((digit, index) => (
              <TextField
                key={index}
                value={digit}
                onChange={(e) => handleChange(e.target.value, index)}
                onKeyDown={(e) => handleKeyDown(e, index)}
                inputRef={(el) => (inputRefs.current[index] = el)}
                inputProps={{
                  maxLength: 1,
                  style: {
                    textAlign: "center",
                    fontSize: "20px",
                    width: "50px",
                  },
                }}
              />
            ))}
          </Box>
          <GradientButton
            width="100%"
            text="Verify OTP"
            onClick={handleVerifyOtp}
          />
        </Box>
      </Box>

      {/* Toast container */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

export default VerifyOtp;
